import { uniqueId, objCameCae, isObject } from "@/views/zhiji/js/common/util.js";
import { transText2Slient, transLinkWord2Server } from "./platTextLink.js";
import i18n from "@/i18n";
import { ParamError } from "@/views/zhiji/js/common/errors.js";

export default {
    widgetName: "Package",
    serverType: "package",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "Package",
            amsId: "",
            groupId: "",
            cardImage: "",
            packageName: "",
            packageDesc: "",
            tips: {
                success: transTips2Client(),
                failed: transTips2Client(),
                repeat: transTips2Client()
            }
        };
    },
    checkContent(content) {
        if (isObject(content)) {
            for (const key in content) {
                if (!content[key]) {
                    throw new ParamError(i18n.t("zhiji.answer.packageWidge.emptyTips"));
                }
            }
        }

        checkTipsContent(content.tips);
    },
    server2Client(content) {
        const {
            tips: { success, failed, repeat }
        } = content;
        const newContent = objCameCae(content, false);

        return Object.assign(
            {
                uId: uniqueId(),
                wtType: "Package",
                ...newContent
            },
            {
                tips: {
                    success: transTips2Client(success),
                    failed: transTips2Client(failed),
                    repeat: transTips2Client(repeat)
                }
            }
        );
    },
    client2Server(content) {
        const {
            tips: { success, failed, repeat }
        } = content;
        const { group_id, ams_id, card_image, package_name, package_desc } = objCameCae(content, true);

        return {
            type: "package",
            group_id,
            ams_id,
            card_image,
            package_name,
            package_desc,
            tips: {
                success: transTips2Server(success),
                failed: transTips2Server(failed),
                repeat: transTips2Server(repeat)
            }
        };
    }
};

function transTips2Server(data) {
    const { textStr, linkWords } = transLinkWord2Server(data);

    return {
        type: "text",
        text: textStr || "",
        url: data.url || "",
        link_word: linkWords || [],
        url_type: ""
    };
}

function transTips2Client(data) {
    const { textStr, linkWords } = data
        ? transText2Slient(data)
        : {
              textStr: "",
              linkWords: []
          };

    return {
        type: "text",
        text: textStr,
        url: (data && data.url) || "",
        linkWord: linkWords,
        urlType: ""
    };
}

function checkTipsContent(data) {
    if (isObject(data)) {
        for (const key in data) {
            if (key === "text" && !data[key]) {
                throw new ParamError(i18n.t("zhiji.answer.packageWidge.emptyTips"));
            } else {
                checkTipsContent(data[key]);
            }
        }
    }
}
